import { QUERY_KEYS } from '../../../../consts';
import { loginService } from '../../../../services';
import { getAtomWithMutation } from '../../../../utils';

export const loginAtom = getAtomWithMutation({
  mutationKey: QUERY_KEYS.USER_SESSION.LOGIN,
  mutationFn: () => loginService,
});
